import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Component from 'react-pure-render/component';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { findResponsavelLAI } from '../leisregemportal/Actions';
import LeiAcessoInformacaoResponsavel from '../leisregemportal/LeiAcessoInformacaoResponsavel.react.js';
import * as actions from './Actions.js';

export class FormAtendimento extends Component {
  static propTypes = {
    atendimento: PropTypes.object.isRequired,
    findAtendimento: PropTypes.func.isRequired,
    findResponsavelLAI: PropTypes.func,
    responsavelLAI: PropTypes.object,
    entidade: PropTypes.object,
    exercicio: PropTypes.object,
    selo: PropTypes.string
  };

  componentDidMount() {
    const {
      atendimento,
      findAtendimento,
      findResponsavelLAI,
      entidade
    } = this.props;
    if (!atendimento.has('id')) {
      findAtendimento(entidade.get('id'));
      findResponsavelLAI();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.entidade != this.props.entidade ||
      nextProps.exercicio != this.props.exercicio
    ) {
      nextProps.findResponsavelLAI();
    }
    if (nextProps.entidade != this.props.entidade) {
      nextProps.findAtendimento(nextProps.entidade.get('id'));
    }
  }

  renderResponsavel = () => {
    const { responsavelLAI } = this.props;

    return <LeiAcessoInformacaoResponsavel responsavelLAI={responsavelLAI} />;
  };

  renderAtendimento = data => {
    if (data.get('id').get('id') == 50) {
      /* Orgão */

      return (
        <h3
          key={data.get('id').get('entidade') + '_' + data.get('id').get('id')}
        >
          <b>{data.get('valor')}</b>
          <br />
          <br />
        </h3>
      );
    } else if (data.get('id').get('id') == 56) {
      /* Horario Atendimento */

      return (
        <h4
          key={data.get('id').get('entidade') + '_' + data.get('id').get('id')}
        >
          <br />
          {data.get('valor')}
          <br />
        </h4>
      );
    } else {
      return (
        <h4 key={data.get('id').get('entidade') + data.get('id').get('id')}>
          <label>{data.get('valor')}</label>
        </h4>
      );
    }
  };

  onClickSelo = () => {
    this.props.history.push('/selo');
  };

  render() {
    const { atendimento, selo } = this.props;

    return (
      <div>
        <Row>
          <Col sm={4}>{atendimento.map(this.renderAtendimento)}</Col>
          <Col sm={4}>{this.renderResponsavel()}</Col>
          {selo && (
            <Col md={4} mdOffset={0} sm={3} smOffset={1}>
              <b>Certificados</b>
              <Row>
                <Col xs={6}>
                  <img
                    className="img-responsive mt-xs"
                    src={`data:image/*;base64,${selo}`}
                    title="Certificado de Qualidade em Transparência Pública"
                    onClick={this.onClickSelo}
                  />
                </Col>
              </Row>
            </Col>
          )}
        </Row>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    atendimento: state.atendimento.get('atendimento'),
    responsavelLAI: state.leiesic.get('responsavelLAI'),
    entidade: state.auth.getIn(['userInfo', 'entidade']),
    exercicio: state.auth.getIn(['userInfo', 'exercicio']),
    selo: state.entidade.getIn(['configuracoesGerais', 'selo'])
  };
}

const allActions = {
  ...actions,
  findResponsavelLAI
};

export default connect(
  mapStateToProps,
  allActions
)(withRouter(FormAtendimento));
